export default class PublicError {
  private errors: Record<string, string[] | string>;

  constructor(errors: Record<string, string[] | string>) {
    this.errors = errors || {};
  }

  public hasError() {
    return Object.keys(this.errors).length > 0;
  }

  public getErrorText(): string {
    if (this.hasError()) {
      return Object.entries(this.errors)
        .map(([, messages]) => {
          if (typeof messages === "string") {
            return messages;
          }
          return messages.join("\n");
        })
        .join("\n\n");
    }
    return "";
  }
}
